const issue_with_renovation = `Hello, I wanted to discuss the recent renovation of my apartment,
particularly the kitchen design. I'm not entirely satisfied with the final result.
There are some aspects in the kitchen that didn't meet my expectations,
and I believe there might be some room for improvement.
I was hoping we could discuss how we might address these concerns.
I appreciate your help in resolving this matter. Thank you.`;

export default issue_with_renovation;